import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-358b7713")

_pushScopeId("data-v-358b7713")
const _hoisted_1 = { class: "flex flex-col w-screen lg:w-full px-4 md:px-8 pt-4 border-b-4 border-primary-100" }
const _hoisted_2 = { class: "flex justify-end items-center mb-2" }
const _hoisted_3 = { class: "user relative" }
const _hoisted_4 = { class: "font-medium text-sm" }
const _hoisted_5 = { class: "user-menu hidden absolute right-0 pt-2 z-20" }
const _hoisted_6 = { class: "bg-white shadow-lg rounded w-56 py-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 ml-1 text-gray-700",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" }),
  /*#__PURE__*/_createVNode("path", { d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "ユーザー設定", -1)
const _hoisted_9 = { class: "ml-1 text-gray-700" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "請求情報を確認", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 ml-1 text-gray-700",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "ログアウト", -1)
const _hoisted_13 = {
  key: 0,
  class: "flex items-center text-sm mb-2"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  viewBox: "0 0 24 24",
  class: "w-3 h-3 mx-2"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M9 5l7 7-7 7" })
], -1)
const _hoisted_15 = { class: "max-w-3xl truncate" }
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = { class: "text-2xl font-bold max-w-3xl truncate" }
const _hoisted_18 = {
  key: 1,
  class: "mt-1 flex whitespace-nowrap overflow-x-scroll"
}
const _hoisted_19 = {
  key: 2,
  class: "pb-6"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.username), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("ul", null, [
              _createVNode("li", {
                class: "list-none flex items-center w-full px-4 py-2 text-sm hover:bg-gray-200 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openUserModal && _ctx.openUserModal(...args)))
              }, [
                _hoisted_7,
                _hoisted_8
              ]),
              (_ctx.accessiblePaymentInfo)
                ? (_openBlock(), _createBlock("li", {
                    key: 0,
                    class: "list-none flex items-center w-full px-4 py-2 text-sm hover:bg-gray-200 cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectCustomerPortal && _ctx.redirectCustomerPortal(...args)))
                  }, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_m_icon, { type: "credit-card" })
                    ]),
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              _createVNode("li", {
                class: "list-none flex items-center w-full px-4 py-2 text-sm hover:bg-gray-200 cursor-pointer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, [
                _hoisted_11,
                _hoisted_12
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.breadcrumbs.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (breadcrumb) => {
            return (_openBlock(), _createBlock(_Fragment, {
              key: breadcrumb.link
            }, [
              _createVNode(_component_router_link, {
                to: breadcrumb.link,
                class: "text-gray-500 transition-all duration-300 hover:text-primary-500"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(breadcrumb.text), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _hoisted_14
            ], 64))
          }), 128)),
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_16, [
      _createVNode("h2", _hoisted_17, _toDisplayString(_ctx.title), 1),
      _renderSlot(_ctx.$slots, "actions")
    ]),
    (_ctx.tabs.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: tab.link,
              to: tab.link,
              class: ["py-2 px-4 font-medium text-sm border-black cursor-pointer transition-colors duration-300 hover:bg-gray-100", {
          'text-gray-500': i != _ctx.currentTabIndex,
          'border-b': i == _ctx.currentTabIndex
        }]
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(tab.text), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_19))
  ]))
})